import React, { FC, ReactNode } from 'react';
import clsx from 'clsx';

type Props = {
  classNames?: {
    line?: string;
    indicator?: string;
  };
  children: ReactNode;
};

const ActivityLogSingleRecordWrapper: FC<Props> = ({
  classNames,
  children,
}) => {
  return (
    <li className="tw-relative tw-flex" data-cy="activity-log-single-record">
      <div
        className={clsx(
          'tw-absolute tw-left-0 tw-top-0 tw-flex tw-w-6 tw-justify-center',
          classNames?.line,
        )}
      >
        <div className="tw-w-px tw-bg-grayscale-20" />
      </div>
      <div className="tw-relative tw-flex tw-h-8 tw-w-6 tw-flex-none tw-items-center tw-justify-center tw-bg-transparent">
        <div
          className={clsx(
            'tw-h-2 tw-w-2 tw-rounded-full tw-ring-1',
            classNames?.indicator,
          )}
        />
      </div>
      <div
        className="tw-flex tw-items-start"
        data-cy="activity-log-single-record-content"
      >
        {children}
      </div>
    </li>
  );
};

export default ActivityLogSingleRecordWrapper;
